import { useEffect } from "react";

const DEFAULT_OG_IMAGE = "https://customer-assets.emergentagent.com/job_304e5314-98a1-43a1-8d90-4b1728467f15/artifacts/k0cmqkhd_Pizza-Excellente.jpg";
const SITE_URL = (process.env.REACT_APP_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "https://www.pizzaexcellente.com")).replace(/\/+$/, "");

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * useSeo — set per-page <head> metadata client-side.
 *
 * @param {{title:string,description:string,path:string,ogImage?:string,ogImageAlt?:string}} opts
 */
export default function useSeo({ title, description, path = "/", ogImage, ogImageAlt }) {
  useEffect(() => {
    if (!title) return;
    const url = `${SITE_URL}${path}`;
    const image = ogImage || DEFAULT_OG_IMAGE;
    document.title = title;
    setMeta("name", "description", description);
    setLink("canonical", url);

    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("property", "og:image:alt", ogImageAlt || title);
    setMeta("property", "og:image:width", "1200");
    setMeta("property", "og:image:height", "630");

    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
  }, [title, description, path, ogImage, ogImageAlt]);
}
